module.exports = __webpack_public_path__ + "static/media/Patti-Garnet--ED.3a165f54.jpg";